import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: {
                // Navbar
                aboutMe: "About Me",
                experience: "Experience",
                projects: "Projects",
                contact: "Contact",
                language: "Language",

                // About Me section
                hello: "👋 Hello!",
                iAm: "I am",
                description:
                    "Android developer with over 3 years of hands-on experience in enterprise environments, focusing on building commercial apps, integrating ads, and optimizing for users.",
                downloadCV: "📄  Download CV",
                contactMe: "✉️  Contact",
                dateOfBirth: "Date of Birth:",
                hometown: "Hometown:",
                phone: "Phone:",
                email: "Email:",
                github: "GitHub:",

                // Skills
                mySkills: "My Skills",
                mainSkills: "💪 Main Skills",
                familiarSkills: "⚡ Familiar Skills",
                otherSkills: "📚 Others",

                // New: Expertise & About Myself
                androidExpertise: "📌 Android Expertise",
                androidExpertiseList: {
                    item1: "Thorough understanding of core Android components such as <b>Activity</b>, <b>Service</b>, <b>Content Provider</b>, and <b>Broadcast Receiver</b>.",
                    item2: "Solid knowledge of changes across different Android versions.",
                    item3: "Experience integrating <b>AdMob</b> and awareness of key considerations when publishing apps on Google Play."
                },
                aboutMyself: "💡 About Myself",
                aboutMyselfList: {
                    item1: "Strong ability to learn quickly, with a high sense of self-study and adaptability.",
                    item2: "Responsible and committed to assigned tasks.",
                    item3: "Motivated to build a long-term career with the company."
                },

                // Experience
                expTitle: "Experience",
                expCompany: "Company",
                expRole: "Role",
                expPeriod: "Period",
                expDesc: "Description",

                // Projects
                projTitle: "Projects",
                projSeeMore: "See more",

                // Contact
                contactTitle: "Contact Me",
                contactName: "Your Name",
                contactEmail: "Your Email",
                contactMessage: "Your Message",
                sendMessage: "Send Message",
            },
        },
        vi: {
            translation: {
                // Navbar
                aboutMe: "Giới thiệu",
                experience: "Kinh nghiệm",
                projects: "Dự án",
                contact: "Liên hệ",
                language: "Ngôn ngữ",

                // About Me section
                hello: "👋 Xin chào!",
                iAm: "Tôi là",
                description:
                    "Lập trình viên Android với hơn 3 năm kinh nghiệm thực tế trong môi trường doanh nghiệp, tập trung phát triển ứng dụng thương mại, tích hợp quảng cáo và tối ưu cho người dùng.",
                downloadCV: "📄  Tải CV",
                contactMe: "✉️  Liên hệ",
                dateOfBirth: "Ngày sinh:",
                hometown: "Quê quán:",
                phone: "SĐT:",
                email: "Email:",
                github: "GitHub:",

                // Skills
                mySkills: "Kỹ năng của tôi",
                mainSkills: "💪 Kỹ năng chính",
                familiarSkills: "⚡ Kỹ năng quen thuộc",
                otherSkills: "📚 Đã từng làm qua",

                // New: Expertise & About Myself
                androidExpertise: "📌 Chuyên môn Android",
                androidExpertiseList: {
                    item1: "Hiểu rõ về các thành phần chính trong Android như <b>Activity</b>, <b>Service</b>, <b>Content Provider</b>, <b>Broadcast Receiver</b>.",
                    item2: "Nắm vững sự thay đổi qua từng phiên bản Android khác nhau.",
                    item3: "Có kinh nghiệm tích hợp quảng cáo <b>AdMob</b> và các lưu ý khi publish ứng dụng lên Google Play."
                },
                aboutMyself: "💡 Về bản thân",
                aboutMyselfList: {
                    item1: "Có khả năng học hỏi, tiếp thu tốt, tinh thần tự học cao.",
                    item2: "Có trách nhiệm với công việc được bàn giao.",
                    item3: "Có mong muốn gắn bó lâu dài với công ty."
                },

                // Experience
                expTitle: "Kinh nghiệm",
                expCompany: "Công ty",
                expRole: "Vị trí",
                expPeriod: "Thời gian",
                expDesc: "Mô tả",

                // Projects
                projTitle: "Dự án",
                projSeeMore: "Xem thêm",

                // Contact
                contactTitle: "Liên hệ với tôi",
                contactName: "Tên của bạn",
                contactEmail: "Email của bạn",
                contactMessage: "Tin nhắn",
                sendMessage: "Gửi tin nhắn",
            },
        },
    },
    lng: "vi", // ngôn ngữ mặc định
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;